import { render } from "./FirstSection.vue?vue&type=template&id=034cc1ea&scoped=true"
import script from "./FirstSection.vue?vue&type=script&lang=js"
export * from "./FirstSection.vue?vue&type=script&lang=js"

import "./FirstSection.vue?vue&type=style&index=0&id=034cc1ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034cc1ea"]])

export default __exports__